export const FILTERING_REDUCER_STATE_ID = 'filtering';
export const AUTOCOMPLETE_PARENT_ID_SEPARATOR = '_';
export const CORE_ID_SEPARATOR = '|';
export const FILTER_TYPE_NUMBER_RANGE_MIN = 0;
export const FILTER_TYPE_NUMBER_RANGE_MAX = 100;
export const FILTER_TYPE_NUMBER_RANGE_STEP = 1;
export const MUI_SELECT_ID_PROPERTY = 'id';
export const REACT_SELECT_ID_PROPERTY = 'value';
export const HIERARCHY_MULTI_SELECT_WIDTH_PX = 362;
